module.exports = __webpack_public_path__ + "img/UK.8e189303.svg";